import axios from "axios";
import { IItemTrackingParameters } from "../interfaces/IItemTrackingParameters";

export async function getTrackingInfoForProduct(code: string): Promise<IItemTrackingParameters | null> {
	try {
		const { data } = await axios.get<IItemTrackingParameters>(`/api/v1/global-tracking/product?code=${code}`);
		return data;
	}
	catch (err) {
		console.error(err);
	}
	return null;
}
